import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from "@/components/ui/sonner";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Tarifs from "@/pages/Tarifs";
import Galerie from "@/pages/Galerie";
import APropos from "@/pages/APropos";
import Contact from "@/pages/Contact";
import ExcellenceNaturelle from "@/pages/ExcellenceNaturelle";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ChatbotWidget from "@/components/ChatbotWidget";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Shop from "@/pages/Shop";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Video from "@/pages/Video";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
        <Routes>
          {/* Admin routes - no navigation/footer */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin" element={<AdminLogin />} />
          
          {/* Public routes - with navigation/footer */}
          <Route path="/*" element={
            <>
              <Navigation />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/tarifs" element={<Tarifs />} />
                  <Route path="/video" element={<Video />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogPost />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/shop/checkout" element={<Checkout />} />
                  <Route path="/galerie" element={<Galerie />} />
                  <Route path="/a-propos" element={<APropos />} />
                  <Route path="/excellence-naturelle" element={<ExcellenceNaturelle />} />
                  <Route path="/contact" element={<Contact />} />
                </Routes>
              </main>
              <Footer />
              <ChatbotWidget />
            </>
          } />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
